function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
/**
 * Vault add-file transaction: create signed upload tx and receive/store it.
 *
 * Client: createVaultAddFileTransaction → peer request "vault add file"
 * Server: receiveVaultAddFileTransaction (via Vault.handlePeerTransaction)
 */

var Transaction = require('../../../../lib/saito/transaction')["default"];
var _require = require('../contracts'),
  buildDefaultAccessScript = _require.buildDefaultAccessScript;

/**
 * Build and sign a vault add-file transaction for the given NFT id.
 * File bytes/name are taken from the Vault module instance (mod.file / mod.filename).
 *
 * @param {object} app
 * @param {object} mod Vault module instance
 * @param {string|null} nftid
 * @param {object|string|null} access_script_obj
 * @returns {Promise<object|null>} signed transaction, or null on failure
 */
function createVaultAddFileTransaction(_x, _x2) {
  return _createVaultAddFileTransaction.apply(this, arguments);
}
/**
 * Peer receive path for "vault add file": deserialize payload and save to Archive.
 *
 * @param {object} app
 * @param {object} mod Vault module instance
 * @param {object} tx peer request transaction
 * @param {function} mycallback
 * @returns {Promise<number>} 1 when handled
 */
function _createVaultAddFileTransaction() {
  _createVaultAddFileTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app, mod) {
    var nftid,
      access_script_obj,
      newtx,
      _app$core,
      access_script,
      access_hash,
      msg,
      _args = arguments,
      _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          nftid = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
          access_script_obj = _args.length > 3 && _args[3] !== undefined ? _args[3] : null;
          _context.n = 1;
          return app.wallet.createUnsignedTransaction();
        case 1:
          newtx = _context.v;
          _context.p = 2;
          if ((_app$core = app.core) !== null && _app$core !== void 0 && (_app$core = _app$core.scripting) !== null && _app$core !== void 0 && _app$core.hash) {
            _context.n = 3;
            break;
          }
          return _context.a(2, null);
        case 3:
          if (nftid) {
            _context.n = 4;
            break;
          }
          console.warn('Vault: createVaultAddFileTransaction missing nftid');
          return _context.a(2, null);
        case 4:
          if (access_script_obj == null) {
            access_script_obj = buildDefaultAccessScript({
              nftid: nftid
            });
          }
          access_script = typeof access_script_obj === 'string' ? access_script_obj : JSON.stringify(access_script_obj);
          access_hash = app.core.scripting.hash(access_script);
          msg = {
            request: 'vault add file',
            access_script: access_script,
            access_hash: access_hash,
            data: {
              file: mod.file,
              name: mod.filename
            }
          };
          newtx.msg = msg;
          _context.n = 5;
          return newtx.sign();
        case 5:
          _context.n = 7;
          break;
        case 6:
          _context.p = 6;
          _t = _context.v;
        case 7:
          return _context.a(2, newtx);
      }
    }, _callee, null, [[2, 6]]);
  }));
  return _createVaultAddFileTransaction.apply(this, arguments);
}
function receiveVaultAddFileTransaction(_x3, _x4, _x5, _x6) {
  return _receiveVaultAddFileTransaction.apply(this, arguments);
}
function _receiveVaultAddFileTransaction() {
  _receiveVaultAddFileTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, mod, tx, mycallback) {
    var archive_mod, peer_tx, peer_txmsg, access_hash, data;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          try {
            archive_mod = app.modules.returnModule('Archive');
            archive_mod.access_hash = 1; // ownership restricted
            peer_tx = new Transaction();
            peer_tx.deserialize_from_web(app, tx.returnMessage().data);
            peer_txmsg = peer_tx.returnMessage();
            access_hash = peer_txmsg.access_hash || '';
            data = {};
            data.owner = access_hash;
            data.preserve = 1;
            app.storage.saveTransaction(peer_tx, data, 'localhost');
            mycallback({
              status: 'success',
              err: ''
            });
          } catch (err) {
            console.error('Vault add file error:', err);
            mycallback({
              status: 'err',
              err: JSON.stringify(err)
            });
          }
          return _context2.a(2, 1);
      }
    }, _callee2);
  }));
  return _receiveVaultAddFileTransaction.apply(this, arguments);
}
module.exports = {
  createVaultAddFileTransaction: createVaultAddFileTransaction,
  receiveVaultAddFileTransaction: receiveVaultAddFileTransaction
};